"use client"

import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

function Switch({
  className,
  color,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  const getSwitchColorClasses = () => {
    if (!color) return 'data-[state=checked]:bg-primary'

    switch (color) {
    case 'blue-500':
      return 'data-[state=checked]:bg-blue-500'
    case 'red-500':
      return 'data-[state=checked]:bg-red-500'
    case 'pink-500':
      return 'data-[state=checked]:bg-pink-500'
    case 'purple-500':
      return 'data-[state=checked]:bg-purple-500'
    case 'green-500':
      return 'data-[state=checked]:bg-green-500'
    case 'amber-500':
      return 'data-[state=checked]:bg-amber-500'
    default:
      return 'data-[state=checked]:bg-blue-500'
    }
  }

  const getFocusRingClasses = () => {
    if (!color) return 'focus-visible:border-ring focus-visible:ring-ring/50'

    switch (color) {
    case 'blue-500':
      return 'focus-visible:border-blue-500 focus-visible:ring-blue-500/50'
    case 'red-500':
      return 'focus-visible:border-red-500 focus-visible:ring-red-500/50'
    case 'pink-500':
      return 'focus-visible:border-pink-500 focus-visible:ring-pink-500/50'
    case 'purple-500':
      return 'focus-visible:border-purple-500 focus-visible:ring-purple-500/50'
    case 'green-500':
      return 'focus-visible:border-green-500 focus-visible:ring-green-500/50'
    case 'amber-500':
      return 'focus-visible:border-amber-500 focus-visible:ring-amber-500/50'
    default:
      return 'focus-visible:border-blue-500 focus-visible:ring-blue-500/50'
    }
  }

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        getSwitchColorClasses(),
        getFocusRingClasses(),
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
